import React from 'react';
import '../../App.css';

const Footer = () => {
    return (
        <div className="footer">
            <p>Copyright © 2021 cabincrewessentials</p>
        </div>
    )
}

export default Footer;
